import type { SVGProps } from 'react';
const SvgBeenhere = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#beenhere_svg__a)">
      <path
        fill="currentColor"
        d="M19 1H5c-1.1 0-1.99.9-1.99 2L3 15.93c0 .69.35 1.3.88 1.66L12 23l8.11-5.41c.53-.36.88-.97.88-1.66L21 3c0-1.1-.9-2-2-2Zm-9 15-5-5 1.41-1.41L10 13.17l7.59-7.59L19 7l-9 9Z"
      />
    </g>
    <defs>
      <clipPath id="beenhere_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgBeenhere;
